export default __webpack_public_path__ + "static/media/nye-lineup.f6b83c37.jpeg";